import { Component, Input, Output, EventEmitter, OnChanges, ElementRef, Renderer2, TemplateRef, input } from '@angular/core';
import { RendererStyleFlags2 } from '@angular/core';
import { ISubheaderRightSection } from '../sub-header.modal';
import { IDropdownEventType } from '../../dropdown/dropdown-model';

@Component({
    selector: 'nalco-subheader-right-section',
    templateUrl: './right-section.component.html',
    standalone: false
})
export class SubHeaderRightSectionComponent implements OnChanges {
    @Input() details: ISubheaderRightSection;
    public rightTemplate = input<TemplateRef<unknown> | null>(null);
    @Output() btnClick= new EventEmitter<string>();
    @Output() ddChange = new EventEmitter<IDropdownEventType>();

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngOnChanges() {
        if (this.details?.inline) {
            setTimeout(() => {
                const btnGrp = this.el.nativeElement.querySelector('.btn-grp');
                if (btnGrp) {
                    this.renderer.setStyle(btnGrp, 'margin-top', '-2.5rem', RendererStyleFlags2.Important);
                }
            });
        }
    }

    btnClickInSubhead(which: string) {
        this.btnClick.emit(which);
    }

    ddChangeInSubheader(data) {
        this.ddChange.emit(data);
    }
}
